const account_center = {
    not_enabled: 'Centrum konta nie jest aktywowane.',
    filed_not_editable: 'Pole nie jest edytowalne.',
};
export default Object.freeze(account_center);
